/// <reference path="../../../node_modules/@types/node/index.d.ts" />

import { h } from 'preact';
import { IEmptyState, ILegalNoticesProps } from '../sgwt-mini-footer.types';
import { ComponentWithDropdown } from '../../common/ComponentWithDropdown';
import { getDidomi } from './cookies-consent';

const NavDropdown = require('react-bootstrap/lib/NavDropdown');
const MenuItem = require('react-bootstrap/lib/MenuItem');

export default class LegalNotices extends ComponentWithDropdown<ILegalNoticesProps, IEmptyState> {
  constructor(props: ILegalNoticesProps) {
    super(props);
  }

  private openDidomiPreferences() {
    const didomi = getDidomi();
    if (didomi !== null) {
      didomi.preferences.show();
    }
  }

  render(props: ILegalNoticesProps): JSX.Element {
    let SGMarketLegalNotices;
    let legalNotices;
    let delimiter;
    if (props.SGMarketLegalNotices) {
      SGMarketLegalNotices = props.SGMarketLegalNotices.map(link => {
        if (link.type === 'cookies-consent') {
          return props.cookiesConsent ?
            <MenuItem onClick={this.openDidomiPreferences}>
              {link.label}
            </MenuItem>
            : null;
        }
        return (
          <MenuItem href={link.value} target="_blank" >{link.label}</MenuItem >
        );
      });
    }
    if (props.legalNotices) {
      legalNotices = props.legalNotices.map(link => (
        <MenuItem href={link.value} target="_blank">{link.label}</MenuItem>
      ));
    }
    if (props.SGMarketLegalNotices && props.legalNotices && props.legalNotices.length) {
      delimiter = <MenuItem divider/>;
    }
    return (
      <NavDropdown
        title={props.label}
        id="sgwt-mini-footer-legal-notices-dropup"
        dropup
        onClick={(evt: any) => this.horribleDropdownHack(evt)}
      >
        { legalNotices }
        { delimiter }
        { SGMarketLegalNotices }
      </NavDropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/LegalNotices.tsx